import React from "react";
import { Badge } from "antd";

const TabWithBadge = ({ title, count, color }) => (
  <span
    style={{
      display: "flex",
      alignItems: "center",
    }}
  >
    {title}
    <Badge
      count={count}
      showZero
      style={{
        marginLeft: 6,
        backgroundColor: count !== 0 ? color || "red" : "#d9d9d9",
      }}
    />
  </span>
);

export default TabWithBadge;
